import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseSharedModule } from '@fuse/shared.module';
import { QuickPanelComponent } from 'app/layout/components/quick-panel/quick-panel-chatDemo/quick-panel.component';
import { SharedModule } from 'app/shared.module';
import { NgApexchartsModule } from 'ng-apexcharts';
import { DataVisualizationSharedModule } from 'app/shared/components/data-visualization';
import { AiChatFeatureModule } from 'app/features/ai-chat';
import { QuickPanelComponentAi } from './quick-panel-chatDemo/quick-panel-data-chat.component';
import { DataBricksAiGenieChatService } from 'app/services/agents/databricks-genie-ai-chat.service';

@NgModule({
  declarations: [QuickPanelComponent, QuickPanelComponentAi],
  imports: [
    MatDividerModule,
    MatListModule,
    MatSlideToggleModule,
    SharedModule,
    FuseSharedModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatTableModule,
    ScrollingModule,
    MatButtonModule,
    NgApexchartsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatSelectModule,
    ReactiveFormsModule,
    AiChatFeatureModule,
    DataVisualizationSharedModule,
  ],
  exports: [QuickPanelComponent, QuickPanelComponentAi],
  providers: [DataBricksAiGenieChatService],
})
export class QuickPanelModule {}
